/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, NgZone, OnChanges, OnDestroy} from '@angular/core';

import {wireModelCommsModelActions} from '../common/controller/model-comms-actions';
import {OBJECT_TYPE} from '../common/constants/object-type';
import template from './campaign-context-actions.component.html';
import {StarService} from '../../components/star/star.service';

@Component({
  standalone: false,
  selector: 'adn-campaign-context-actions',
  template
})
export class CampaignContextActionsComponent implements OnChanges, OnDestroy {
  @Input() model: any;
  @Input() modelComms: any;
  @Input() isNew: boolean;
  @Input() readOnly: boolean;

  readonly confirmation = {
    warningMessage: "The {{action}} of the Campaign will also stop it from serving ads.",
    object: 'Campaign'
  };

  isStarred = false;
  private destroyed = false;

  constructor(
    @Inject(StarService) private readonly StarService: any,
    private readonly ngZone: NgZone
  ) {
  }

  get objectId(): string {
    return this.model?.id;
  }

  get objectType(): string {
    return OBJECT_TYPE.LineItem.type;
  }

  ngOnChanges(): void {
    if (this.model && this.modelComms) {
      wireModelCommsModelActions(this.modelComms);
    }
    this.refreshStar();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  toggleStar(): void {
    if (!this.objectId) {
      return;
    }
    const objectType = OBJECT_TYPE.LineItem;
    const newStarred = !this.isStarred;
    this.StarService.updateStar(this.objectId, objectType, newStarred).then(() => {
      if (!this.destroyed) {
        this.ngZone.run(() => {
          this.isStarred = newStarred;
        });
      }
    });
  }

  private refreshStar(): void {
    if (!this.objectId) {
      this.isStarred = false;
      return;
    }
    this.isStarred = this.StarService.isStarred(this.objectId, OBJECT_TYPE.LineItem);
  }
}
